module.exports = __webpack_public_path__ + "img/logo-m.d73b5397.png";